/* ==========================================================================
   ActivoHub theme — storefront interactions.

   IMPORTANT: this file never touches checkout. Cart mutations go through
   Shopify's own /cart AJAX endpoints, and the checkout hand-off is a plain
   form POST to /cart with name="checkout". Payment configuration lives in
   Settings > Payments and is not reachable from theme code.
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.ActivoHub && window.ActivoHub.routes) || {};

  /* ---------------- Drawers ---------------- */
  function drawers() { return document.querySelectorAll('.drawer'); }
  function openDrawer(name) {
    Array.prototype.forEach.call(drawers(), function (d) {
      d.dataset.open = String(d.dataset.drawer === name);
    });
    var s = document.getElementById('scrim');
    if (s) s.dataset.open = 'true';
    document.body.classList.add('no-scroll');
  }
  function closeDrawers() {
    Array.prototype.forEach.call(drawers(), function (d) { d.dataset.open = 'false'; });
    var s = document.getElementById('scrim');
    if (s) s.dataset.open = 'false';
    document.body.classList.remove('no-scroll');
  }

  /* ---------------- Cart ---------------- */
  function refreshCart() {
    return fetch(routes.cart_url + '?section_id=cart-drawer-refresh', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
          el.textContent = cart.item_count;
        });
        // Re-render the drawer from the server so prices, discounts and
        // shipping thresholds always match what checkout will charge.
        return fetch(window.location.pathname + '?view=cart-fragment')
          .catch(function () { return null; })
          .then(function () { window.location.reload(); });
      });
  }

  function addToCart(form) {
    var data = new FormData(form);
    var btn = form.querySelector('[name="add"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; }
        if (!res.ok) {
          // Inline, on-brand error rather than a browser alert. Most common
          // cause is a variant selling out between page load and click.
          var msg = form.querySelector('[data-cart-error]');
          if (!msg) {
            msg = document.createElement('p');
            msg.setAttribute('data-cart-error', '');
            msg.className = 'msg';
            msg.style.cssText = 'background:#FDECEC;border:1px solid #F5B5B5;color:#8A1F1F';
            (btn && btn.parentNode) ? btn.parentNode.insertBefore(msg, btn.nextSibling) : form.appendChild(msg);
          }
          msg.textContent = res.body.description || res.body.message || 'Sorry — we could not add that to your cart. Please try again.';
          return;
        }
        window.location.href = routes.cart_url;
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; }
        form.submit(); // fall back to a normal POST so the customer is never stuck
      });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(function () { window.location.reload(); });
  }

  /* ---------------- Wire up ---------------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open-drawer]');
    if (open) { e.preventDefault(); openDrawer(open.dataset.openDrawer); return; }
    if (e.target.closest('[data-close-drawer]') || e.target.id === 'scrim') { closeDrawers(); return; }

    var q = e.target.closest('[data-qty-line]');
    if (q) { e.preventDefault(); changeLine(q.dataset.qtyLine, q.dataset.qtyValue); return; }

    var thumb = e.target.closest('#thumbs button');
    if (thumb) {
      Array.prototype.forEach.call(document.querySelectorAll('#thumbs button'), function (b) {
        b.setAttribute('aria-current', 'false');
      });
      thumb.setAttribute('aria-current', 'true');
      var hero = document.getElementById('hero-img');
      if (hero) { hero.src = thumb.dataset.src; hero.alt = thumb.dataset.alt || ''; }
      return;
    }

    var sw = e.target.closest('.swatch');
    if (sw) {
      var group = sw.parentElement;
      Array.prototype.forEach.call(group.querySelectorAll('.swatch'), function (b) { b.setAttribute('aria-current', 'false'); });
      sw.setAttribute('aria-current', 'true');
      var select = document.getElementById('variant-select');
      if (select) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].text.indexOf(sw.dataset.value) > -1) { select.selectedIndex = i; break; }
        }
        var priceEl = document.querySelector('[data-price]');
        if (priceEl && select.options[select.selectedIndex]) {
          priceEl.textContent = select.options[select.selectedIndex].dataset.price || priceEl.textContent;
        }
      }
    }

    var menu = e.target.closest('.has-menu > button');
    if (menu) {
      e.stopPropagation();
      var m = menu.parentElement;
      var isOpen = m.dataset.open === 'true';
      m.dataset.open = String(!isOpen);
      menu.setAttribute('aria-expanded', String(!isOpen));
      return;
    }
    Array.prototype.forEach.call(document.querySelectorAll('.has-menu'), function (m) {
      m.dataset.open = 'false';
      var b = m.querySelector('button'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  // Hover intent on pointer devices
  Array.prototype.forEach.call(document.querySelectorAll('.has-menu'), function (m) {
    m.addEventListener('mouseenter', function () {
      if (window.matchMedia('(hover:hover)').matches) { m.dataset.open = 'true'; }
    });
    m.addEventListener('mouseleave', function () {
      if (window.matchMedia('(hover:hover)').matches) { m.dataset.open = 'false'; }
    });
  });

  // Product form -> AJAX add, with a normal-POST fallback
  var pform = document.getElementById('product-form');
  if (pform) {
    pform.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name !== 'add') return; // let payment buttons through untouched
      e.preventDefault();
      addToCart(pform);
    });
  }

  // Bundle radios drive the CTA label
  var bundles = document.getElementById('bundles');
  if (bundles) {
    bundles.addEventListener('change', function (e) {
      var amt = e.target.closest('.bundle').querySelector('.amt');
      var btn = document.getElementById('atc');
      if (btn && amt) btn.textContent = 'Add to cart — ' + amt.textContent.trim();
    });
  }

  // Announcement rotator
  var track = document.getElementById('announce');
  if (track && track.children.length > 1) {
    var i = 0, n = track.children.length;
    setInterval(function () {
      i = (i + 1) % n;
      track.style.transition = 'transform .45s ease-out';
      track.style.transform = 'translateY(-' + (i * 16) + 'px)';
    }, 4500);
  }

  // Active nav state
  var path = window.location.pathname.replace(/\/$/, '');
  Array.prototype.forEach.call(document.querySelectorAll('.nav a, .mobilenav a'), function (a) {
    var href = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
    if (href && href === path) a.setAttribute('aria-current', 'page');
  });
})();
